import I18n from 'i18n-js'
import json from '../../../config/locales/javascript.de.json'
I18n.locale = 'de'
I18n.translations = { de: json }
global.I18n = I18n
